export default "__VITE_ASSET__DMsifUnH__"